import { Pipe, PipeTransform } from '@angular/core';
import { ApiService } from '../../shared/api.service';

@Pipe({
  name: 'country',
})
export class CountryPipe implements PipeTransform {
  constructor(private apiService: ApiService) {}
  transform(value: string): { name: string; abbreviation: string } {
    return this.apiService
      .getCountries()
      .find((country) => country.abbreviation === value);
  }
}
